module.exports = __webpack_public_path__ + "media/images/e-bilet/directions/odesa-kharkiv-37ddef40b946142ee9a79899d5b05198.png";